export const ACTION_CONFIRM_DIALOG_OPEN='ACTION_CONFIRM_DIALOG_OPEN';
export const ACTION_CONFIRM_DIALOG_CLOSE='ACTION_CONFIRM_DIALOG_CLOSE';
export const ACTION_CONFIRM_DIALOG2_OPEN='ACTION_CONFIRM_DIALOG2_OPEN';
export const ACTION_CONFIRM_DIALOG2_CLOSE='ACTION_CONFIRM_DIALOG2_CLOSE';


// WEBPACK FOOTER //
// ./src/redux/actConfDialog/actionTypes.js